import {uuidRegex} from '@/config/constants';

const compiledUUID = new RegExp(uuidRegex, 'i');

function isUuidFormat(value?: string) {
  return compiledUUID.test(value || '');
}

export default isUuidFormat;
